__turbopack_context__.v({
  "container": "InlineQuote-module-scss-module__ST-SMW__container",
  "customer": "InlineQuote-module-scss-module__ST-SMW__customer",
  "quote": "InlineQuote-module-scss-module__ST-SMW__quote",
});
